import apiClient from '../auth/http-interceptor.jsx';

class BaseService {
  constructor(baseURL = '') {
    this.baseURL = baseURL;
    this.client = apiClient;
  }

  async get(endpoint, params = {}) {
    try {
      const response = await this.client.get(`${this.baseURL}${endpoint}`, { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async post(endpoint, data = {}) {
    try {
      const response = await this.client.post(`${this.baseURL}${endpoint}`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async put(endpoint, data = {}) {
    try {
      const response = await this.client.put(`${this.baseURL}${endpoint}`, data);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async delete(endpoint) {
    try {
      const response = await this.client.delete(`${this.baseURL}${endpoint}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        status: error.response.status,
        message: error.response.data?.message || error.response.data?.detail || 'An error occurred',
        data: error.response.data,
      };
    } else if (error.request) {
      // Request made but no response
      return {
        status: 0,
        message: 'Network error. Please check your connection.',
        data: null,
      };
    } else {
      // Something else happened
      return {
        status: -1,
        message: error.message || 'An unexpected error occurred',
        data: null,
      };
    }
  }
}

export default BaseService;